(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/bankid-errorhandling.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/bankid-errorhandling.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.behaviors.BankIDErrorHandling = Marionette.Behavior.extend({
    onBankIDError: function onBankIDError(xhr) {
      var _this = this;

      var logger = svs.core.log.getLogger('module:player-login');
      var errorCode, errorMessage;

      var errorFunction = function errorFunction() {
        if (_this.view.model.get('isCustomerRegistration')) {
          svs.utils.url.navigate(svs.utils.urlMapping.get('customerRegistrationHome'));
        } else {
          svs.utils.url.navigate(_this.view.model.get('returnUrl') || svs.utils.urlMapping.get('startPage'));
        }
      };

      if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
        errorCode = xhr.responseJSON.error.code;
      }

      switch (errorCode) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 8:
        case 9:
        case 10:
        case 12:
        case 13:
        case 14:
        case 15:
        case 18:
        case 19:
        case 20:
        case 41:
        case 42:
        case 43:
        case 46:
        case 47:
        case 48:
        case 49:
        case 53:
        case 54:
        case 55:
          errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
          break;

        case 56:
          errorMessage = this.view.model.get('sameDevice') ? 
          'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din internetbank. Försök sedan igen.' : 'Du har väntat för länge med att starta din BankID-app, var vänlig försök att logga in igen.';
          break;

        case 7:
        case 11:
        case 16:
        case 17:
          errorMessage = 'Kan inte logga in dig, var vänlig kontakta Kundservice 0770 - 11 11 11';
          break;

        case 44:
          errorMessage = 'Det går inte att logga in just nu, prova att uppdatera BankID appen.';
          break;

        case 45:
          errorMessage = 'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank';
          break;

        case 50:
          errorMessage = 'Inloggningen avbruten, var vänlig försök igen';
          break;

        case 51:
        case 52:
          logger.debug("Login aborted by user ".concat(errorCode)); 

          svs.core.flash('info', {
            title: 'Inloggning avbruten',
            area: svs.components.dialog.area.POPUP,
            branding: svs.components.dialog.branding.TUR,
            icon: 'exclamation-sign',
            time: svs.components.dialog.autoClose.MEDIUM 

          }, errorFunction);
          break;

        case 22:
          errorMessage = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
          break;

        default:
          logger.error('Unhandled login error', xhr);
          errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      }

      if (errorMessage) {
        var dialog = new svs.components.dialog.Confirm({
          type: svs.components.dialog.type.ERROR,
          title: 'Misslyckad inloggning',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: errorMessage
          }],
          actions: [{
            title: 'OK',
            callback: errorFunction
          }]
        });
        svs.components.dialog.api.add(dialog);
      }
    }
  });
})(Backbone, _, svs);
 })(window);